export const alarmFilterOption = function (that) {
  return {
    menuBtn: false,
    labelWidth: 80,
    labelPosition: 'left',
    gutter: 10,
    size: 'mini',
    column: [
      // {
      //   label: that.$t('historyAlarm.title.alarmArea'),
      //   labelWidth: 40,
      //   prop: 'alarmArea',
      //   formslot: true,
      //   span: 5,
      //   search:false
      // },
      {
        label: '所属中队',
        prop: 'securityWorkGroupName',
        editDisabled: false,
        addDisplay: true,
        editDisplay: true,
        //search: true,
        overHidden: true,
        span: 5
      },

      {
        label: '告警标题',
        // labelWidth: 140,
        prop: 'alarmTitle',
        formslot: false,
        span: 5
      },
      {
        label: '告警来源',
        // labelWidth: 140,
        prop: 'deviceName',
        formslot: true,
        span: 5
      },
      // {
      //   label: '开始时间',
      //   prop: 'beginTime',
      //   type: 'datetime',
      //   span: 6
      // },
      // {
      //   label: '结束时间',
      //   prop: 'endTime',
      //   type: 'datetime',
      //   span: 6
      // },
      {
        label: that.$t('historyAlarm.title.alarmTime'),
        prop: 'date',
        formslot: true,
        // value: 'daterange',
        // type: 'daterange',
        // startPlaceholder: that.$t('historyAlarm.placeholder.startDate'),
        // endPlaceholder: that.$t('historyAlarm.placeholder.endDate'),
        // pickerOptions: {
        //   disabledDate(time) {
        //     let curDate = (new Date()).getTime();
        //     let three = 90 * 24 * 3600 * 1000;
        //     let threeMonths = curDate - three;
        //     return time.getTime() >= Date.now() || time.getTime() < threeMonths;
        //   }
        // },
        span: 8,
      },

      {
        label: '',
        prop: 'searchBtn',
        formslot: true,
        span: 5
      }
    ]
  }
}